import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from "reactstrap";
import SvgIcon from "../../Components/CommonComponents/SvgIcon/SvgIcon";
import { PropsTypes } from "../../Types/CommonElementType";
import H4 from "../Headings/H4Element";

const Breadcrumbs: React.FC<PropsTypes> = ({ mainTitle, parent }) => {
  return (
    <>
      <Container fluid>
        <div className="page-title">
          <Row>
            <Col sm="6" xs="12">
              <H4>{mainTitle}</H4>
            </Col>
            <Col sm="6" xs="12">
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                    <SvgIcon className="stroke-icon" iconId="stroke-home" />
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>{parent}</BreadcrumbItem>
                <BreadcrumbItem active>{mainTitle}</BreadcrumbItem>
              </Breadcrumb>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Breadcrumbs;
